import { render, staticRenderFns } from "./DatiGeneraliViewComponent.vue?vue&type=template&id=046bb67f"
import script from "./DatiGeneraliViewComponent.vue?vue&type=script&lang=js"
export * from "./DatiGeneraliViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports